<div class="main-page container">
  <fc-bread-crumb-navigation
    [navigationString]="
      'Manage Info / Cohorts / ' + (cohortForm?.value.id ? 'Edit' : 'Add a New') + ' Cohort'
    "></fc-bread-crumb-navigation>
  <div class="main-panel">
    <div class="error-message">{{ error }}</div>
    <ng-container *ngIf="cohortForm">
      <form [formGroup]="cohortForm" fcFormUnloadWarning>
        <input formControlName="id" type="hidden" />
        <div class="form-container">
          <div class="fields">
            <mat-form-field class="w-100-1">
              <mat-label>Cohort Name</mat-label>
              <input formControlName="name" id="name" matInput type="text" />
            </mat-form-field>
            <mat-form-field class="w-50-2">
              <mat-label>Define the Cohort Geography</mat-label>
              <mat-select formControlName="region">
                <mat-option *ngFor="let region of regions" [value]="region.id">
                  {{ region.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field class="w-50-2">
              <mat-label>Methodology</mat-label>
              <mat-select formControlName="methodology">
                <mat-option value="SNIPFL">SNIPFL</mat-option>
              </mat-select>
            </mat-form-field>
            <div class="double-row">
              <div>
                <fc-datepicker
                  [dateFilterErrorMessage]="'Enrollment must start on the <b>first day of the month</b>.'"
                  [datepickerFilter]="firstDateFilter"
                  [maxDate]="cohortForm.value.enrollmentEndDateForm"
                  formControlName="enrollmentStartDateForm"
                  formFieldClass="w-100-1"
                  inputID="enrollmentStartDate"
                  label="Enrollment Start Date"></fc-datepicker>
              </div>
              <div>
                <fc-datepicker
                  [dateFilterErrorMessage]="'Enrollment must end on the <b>last day of the month</b>.'"
                  [datepickerFilter]="endDateFilter"
                  [minDate]="cohortForm.value.enrollmentStartDateForm"
                  formControlName="enrollmentEndDateForm"
                  formFieldClass="w-100-1"
                  inputID="enrollmentEndDate"
                  label="Enrollment End Date"></fc-datepicker>
              </div>
            </div>
            <div class="double-row">
              <div>
                <fc-datepicker
                  [maxDate]="cohortForm.value.enrollmentEndDateForm"
                  formControlName="startDateForm"
                  formFieldClass="w-100-1"
                  inputClass="cohort-input"
                  inputID="projectStartDate"
                  tooltip="The site start date is when the group of cohorts is started in ACR. It should be the same for all cohorts in this site."
                  label="Project Start Date"></fc-datepicker>
              </div>
              <div>
                <mat-form-field class="w-100-1">
                  <mat-label>ACR Project Name</mat-label>
                  <input formControlName="acrProjectName" id="acrProjectName" matInput type="text" />
                </mat-form-field>
              </div>
            </div>
            <mat-form-field class="w-100-1">
              <mat-label>Buyer</mat-label>
              <mat-select
                (selectionChange)="updateDocusignTemplates($event)"
                class="select-control buyer-select"
                formControlName="buyer">
                <mat-option *ngFor="let buyer of buyers" [value]="buyer.id">
                  {{ buyer.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <div *ngIf="buyers && buyers.length === 0">No buyers loaded</div>
            <div class="double-row">
              <div>
                <mat-form-field class="w-100-1">
                  <mat-label>Pay Period Cadence</mat-label>
                  <mat-select class="select-control pay-cadence-select" formControlName="payPeriodCadence">
                    <mat-option [value]="1">Every 1 month</mat-option>
                    <mat-option [value]="3">Every 3 months</mat-option>
                    <mat-option [value]="6">Every 6 months</mat-option>
                    <mat-option [value]="12">Every 12 months</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="double-row">
              <div>
                <mat-form-field class="w-100-1">
                  <mat-label>Price per Ton</mat-label>
                  <input currencyMask formControlName="pricePerTon" id="pricePerTon" matInput type="text" />
                </mat-form-field>
              </div>
              <div>
                <mat-form-field class="w-100-1">
                  <mat-label>
                    Internal Buffer Value
                    <fa-icon
                      #tooltip="matTooltip"
                      (click)="tooltip.toggle()"
                      [icon]="['far', 'circle-info']"
                      class="blue"
                      matTooltip="The internal buffer value, in decimal form. A buffer value of 15% should be entered as 0.15"
                      matTooltipClass="fc-tooltip"
                      matTooltipPosition="right"></fa-icon>
                  </mat-label>
                  <input formControlName="internalBufferValue" id="internalBufferValue" matInput type="text" />
                </mat-form-field>
              </div>
            </div>
            <div class="double-row">
              <div>
                <mat-form-field class="w-100-1">
                  <mat-label>
                    Initial Fixed Years
                    <fa-icon
                      #tooltip="matTooltip"
                      (click)="tooltip.toggle()"
                      [icon]="['far', 'circle-info']"
                      class="blue"
                      matTooltip="The number of fixed price years. After X years, the pricing model will shift to a variable rate, and any changes to the PPT will cause a re-calculation of any payment period greater than this value. This value should equal the number of total payment periods in the case of fully fixed pricing."
                      matTooltipClass="fc-tooltip"
                      matTooltipPosition="right"></fa-icon>
                  </mat-label>
                  <input
                    formControlName="initialFixedYears"
                    id="initialFixedYears"
                    matInput
                    type="number"
                    pattern="[0-9]*"
                    min="0"
                    max="20" />
                </mat-form-field>
              </div>
              <div>
                <mat-form-field class="w-100-1">
                  <mat-label>
                    Market Price Percentage
                    <fa-icon
                      #tooltip="matTooltip"
                      (click)="tooltip.toggle()"
                      [icon]="['far', 'circle-info']"
                      class="blue"
                      matTooltip="The percentage of market price to pay the landowner during variable years, in decimal form. A value of 55% should be entered as 0.55"
                      matTooltipClass="fc-tooltip"
                      matTooltipPosition="right"></fa-icon>
                  </mat-label>
                  <input formControlName="marketPricePercentage" id="marketPricePercentage" matInput type="text" />
                </mat-form-field>
              </div>
            </div>
            <div class="double-row">
              <div>
                <mat-form-field class="w-100-1">
                  <mat-label>Minimum Payment per Acre</mat-label>
                  <input
                    currencyMask
                    formControlName="minimumPaymentPerAcre"
                    id="minimumPaymentPerAcre"
                    matInput
                    type="text" />
                </mat-form-field>
              </div>
              <div>
                <mat-form-field class="w-100-1">
                  <mat-label>Minimum ERT per Acre</mat-label>
                  <input formControlName="minimumErtPerAcre" id="minimumErtPerAcre" matInput type="text" />
                </mat-form-field>
              </div>
            </div>
            <div class="double-row">
              <div>
                Bonus is PPT
                <fa-icon
                  #tooltip="matTooltip"
                  [icon]="['far', 'circle-info']"
                  class="blue"
                  matTooltip="The PPT bonus will be calculated based on the yearly valuation."
                  matTooltipClass="fc-tooltip"
                  matTooltipPosition="right"></fa-icon>
                <mat-slide-toggle
                  color="primary"
                  formControlName="bonusIsPpt"
                  data-cy="show-modify-toggle"></mat-slide-toggle>
              </div>
              <div>
                <mat-form-field class="w-100-1">
                  <mat-label>Bonus Amount</mat-label>
                  <input currencyMask formControlName="bonusAmount" id="bonusAmount" matInput type="text" />
                </mat-form-field>
              </div>
              <div>
                <mat-form-field class="w-100-1">
                  <mat-label>Bonus Length (# of Periods)</mat-label>
                  <input
                    formControlName="bonusLength"
                    id="bonusLength"
                    matInput
                    type="number"
                    pattern="[0-9]*"
                    min="0" />
                </mat-form-field>
              </div>
            </div>
            <mat-form-field class="w-100-1">
              <mat-label>Terms URL</mat-label>
              <input formControlName="termsUrl" id="termsUrl" matInput type="text" />
            </mat-form-field>
            <mat-form-field class="w-100-1">
              <mat-label>Terms 1</mat-label>
              <input formControlName="terms1" id="terms1" matInput type="text" />
            </mat-form-field>
            <mat-form-field class="w-100-1">
              <mat-label>Terms 2</mat-label>
              <input formControlName="terms2" id="terms2" matInput type="text" />
            </mat-form-field>
            <mat-form-field class="w-100-1">
              <mat-label>Terms 3</mat-label>
              <input formControlName="terms3" id="terms3" matInput type="text" />
            </mat-form-field>
            <mat-form-field class="w-50-2">
              <mat-label>Docusign Template</mat-label>
              <mat-select class="select-control buyer-select" formControlName="docusignTemplateId">
                <mat-option>None</mat-option>
                <mat-option *ngFor="let template of templates" [value]="template.id">
                  {{ template.description }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <div class="w-25-4">
              Only Once?
              <fa-icon
                #tooltip="matTooltip"
                [icon]="['far', 'circle-info']"
                class="blue"
                matTooltip="Is the docusign template required just once?"
                matTooltipClass="fc-tooltip"
                matTooltipPosition="right"></fa-icon>
              <mat-slide-toggle
                color="primary"
                formControlName="docusignOneTime"
                data-cy="show-modify-toggle"></mat-slide-toggle>
            </div>
            <mat-divider [ngStyle]="{ 'margin-top': '45px' }"></mat-divider>
            <button
              (click)="onSubmit()"
              [disabled]="cohortForm.invalid || !isSuperAdmin"
              class="submit-button"
              color="primary"
              data-cy="button-submit"
              mat-raised-button>
              {{ cohortForm.value.id ? 'Update' : 'Create' }} Cohort
            </button>
            <button
              (click)="cloneCohort()"
              *ngIf="cohortForm.value.id"
              class="submit-button"
              color="primary"
              data-cy="button-clone"
              mat-raised-button>
              Clone Cohort
            </button>
          </div>
        </div>
      </form>
      <div class="welcome-documents" *ngIf="cohortForm.value.id">
        <h4>Welcome Documents</h4>
        <div *ngFor="let doc of welcomeDocs">
          <fa-icon
            (click)="removeWelcomeDoc($event, doc)"
            *ngIf="isSuperAdmin"
            [icon]="['far', 'trash']"
            class="red"></fa-icon>
          <a [href]="doc.url" class="doc-link" target="_blank">
            {{ doc.name }}
          </a>
        </div>
        <mat-divider [ngStyle]="{ 'margin-top': '45px' }"></mat-divider>
        <button
          (click)="uploadWelcomeDoc($event)"
          [disabled]="!isSuperAdmin"
          class="submit-button"
          color="primary"
          mat-raised-button>
          Upload a Document
        </button>
      </div>
    </ng-container>
  </div>
</div>
<input
  #welcomeDocFileUpload
  accept=".pdf,.doc,.docx,.odt,.ppt,.pptx,.png,.jpg,.gif"
  hidden
  id="yieldCurveFileUpload"
  name="yieldCurveFileUpload"
  type="file" />
